// extracted by mini-css-extract-plugin
export default {"keyBodyMetricsTable":"XWu1FG3GiNOq0gZ7Tqh1","headerRow":"E_an8ojbPTwJ_ybT1yrg","row":"Sx2pvByiSCyVgtNN0YEC","titleCell":"b6GPr6bigjuPBBt0vN2G","description":"uJmAHFElh6x1Bt_0MGKt"};